import React from 'react';
import { createIcon } from './create-icon';
import './icon-attach-to-row.scss';

export const IconAttachToRow = createIcon(<div className="icon-attach-to-row" />);
